import React from "react";
import {hot} from "react-hot-loader";
import {Provider} from "react-redux";
import {ToastContainer} from "react-toastify";
import getStore from "./utils/getStore";
import BlogsPage from "./components/site/page/BlogsPage";

function BlogsRoot() {

    return (
        <Provider store={getStore()}>
            <React.Fragment>
                <BlogsPage />
                <ToastContainer />
            </React.Fragment>
        </Provider>
    );
}

if (DEVELOPMENT) {
    BlogsRoot = hot(module)(BlogsRoot);
}

export default BlogsRoot;
